"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactHotLoader = require("react-hot-loader");
var childrenUtils = _interopRequireWildcard(require("../../utils/children"));
var refsUtils = _interopRequireWildcard(require("../../utils/refs"));
var _Toggle = _interopRequireDefault(require("../Toggle"));
var _Tab = _interopRequireDefault(require("./Tab"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "container": "container_FrVhDK",
  "tabs-title": "tabs-title_2QyvsW",
  "tabsTitle": "tabs-title_2QyvsW",
  "tabs": "tabs_1qj5IT",
  "is-collapsed": "is-collapsed_1FVqZ3",
  "isCollapsed": "is-collapsed_1FVqZ3",
  "toggle": "toggle_3-sJ-e",
  "is-expanded": "is-expanded_3OA1SA",
  "isExpanded": "is-expanded_3OA1SA",
  "tab": "tab_3TVKpi",
  "selected": "selected_1jb2hS",
  "toggle-content": "toggle-content_AEnzfS",
  "toggleContent": "toggle-content_AEnzfS",
  "content": "content_3Vbr1c",
  "hidden": "hidden_3F1I8l"
}; 
require('./CollapsibleTabs.css');
var getTabRefs = (0, _memoizeOne.default)(function (children) {
  var tabsCount = childrenUtils.countChildren(children, _Tab.default);
  return Array.from({
    length: tabsCount
  }).map(function () {
    return /*#__PURE__*/_react.default.createRef();
  });
});
var isTab = function isTab(child) {
  return child && (0, _reactHotLoader.areComponentsEqual)(child.type, _Tab.default);
};
var CollapsibleTabs = /*#__PURE__*/function (_React$Component) {
  function CollapsibleTabs() {
    var _this;
    (0, _classCallCheck2.default)(this, CollapsibleTabs);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CollapsibleTabs, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      isCollapsed: !_this.props.startExpanded,
      selectedTabIndex: _this.props.initialIndex
    });
    (0, _defineProperty2.default)(_this, "handleSelect", function (_ref) {
      var event = _ref.event,
        index = _ref.index;
      _this.props.onTabSelect({
        event: event,
        index: index
      });
      _this.props.onToggle({
        event: event,
        index: index,
        isCollapsed: false,
        isToggleClick: false
      });
      _this.setState({
        isCollapsed: false,
        selectedTabIndex: index
      });
    });
    (0, _defineProperty2.default)(_this, "focusPrev", function (_ref2) {
      var index = _ref2.index;
      var children = _this.props.children;
      var tabRefs = getTabRefs(children);
      var ref;
      if (index === 0) {
        ref = tabRefs[tabRefs.length - 1];
      } else {
        ref = tabRefs[index - 1];
      }
      refsUtils.focus(ref);
    });
    (0, _defineProperty2.default)(_this, "focusNext", function (_ref3) {
      var index = _ref3.index;
      var children = _this.props.children;
      var tabRefs = getTabRefs(children);
      var ref;
      if (index === tabRefs.length - 1) {
        ref = tabRefs[0];
      } else {
        ref = tabRefs[index + 1];
      }
      refsUtils.focus(ref);
    });
    (0, _defineProperty2.default)(_this, "handleToggle", function (event) {
      var isCollapsed = !_this.state.isCollapsed;
      var selectedTabIndex = _this.state.selectedTabIndex;
      _this.props.onToggle({
        isCollapsed: isCollapsed,
        event: event,
        index: selectedTabIndex,
        isToggleClick: true
      });
      _this.setState({
        isCollapsed: isCollapsed
      });
    });
    return _this;
  }
  (0, _inherits2.default)(CollapsibleTabs, _React$Component);
  return (0, _createClass2.default)(CollapsibleTabs, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        ariaLabel = _this$props.ariaLabel,
        children = _this$props.children,
        className = _this$props.className,
        id = _this$props.id;
      var _this$state = this.state,
        isCollapsed = _this$state.isCollapsed,
        selectedTabIndex = _this$state.selectedTabIndex;
      var tabRefs = getTabRefs(children);
      var tabsCount = tabRefs.length;
      var lastIndex = 0;
      var tabs = _react.default.Children.map(children, function (child) {
        if (!isTab(child)) {
          return child;
        }
        lastIndex += 1;
        var index = lastIndex - 1;
        var isSelected = selectedTabIndex === index;
        var isTabbable = selectedTabIndex === null ? index === 0 : isSelected;
        return /*#__PURE__*/_react.default.cloneElement(child, {
          index: index,
          isSelected: !isCollapsed && isSelected,
          ref: tabRefs[index],
          isTabbable: isTabbable,
          parentId: id,
          onSelect: function onSelect(event) {
            return _this2.handleSelect({
              event: event,
              index: index
            });
          },
          onMoveLeft: function onMoveLeft() {
            return _this2.focusPrev({
              index: index
            });
          },
          onMoveRight: function onMoveRight() {
            return _this2.focusNext({
              index: index
            });
          }
        });
      });
      var selectableTabs = tabs.filter(isTab);
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "collapsible-tabs",
        className: (0, _classnames.default)(styles.container, className),
        role: "tablist",
        "aria-label": ariaLabel
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(styles.tabs, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, styles.isCollapsed, isCollapsed), styles.isExpanded, !isCollapsed))
      }, tabs, /*#__PURE__*/_react.default.createElement(_Toggle.default, {
        ariaControls: "".concat(id, "-").concat(selectedTabIndex, "-panel"),
        isCollapsed: isCollapsed,
        onToggle: this.handleToggle,
        className: styles.toggle
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: styles.toggleContent
      }, isCollapsed ? 'expand' : 'collapse'))), Array.from({
        length: tabsCount
      }, function (value, index) {
        var isSelected = selectedTabIndex === index;
        return /*#__PURE__*/_react.default.createElement("div", {
          "data-test-id": "collapsible-tabs-panel",
          className: (0, _classnames.default)(styles.content, (0, _defineProperty2.default)({}, styles.hidden, isCollapsed || !isSelected)),
          key: index,
          id: "".concat(id, "-").concat(index, "-panel"),
          role: "tabpanel",
          tabIndex: isSelected ? '0' : '-1',
          "aria-labelledby": "".concat(id, "-").concat(index, "-tab")
        }, isSelected ? selectableTabs[selectedTabIndex].props.children : null);
      }));
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(CollapsibleTabs, "defaultProps", {
  id: 'collapsible-tabs',
  onTabSelect: function onTabSelect() {},
  onToggle: function onToggle() {},
  initialIndex: 0,
  startExpanded: false
});
(0, _defineProperty2.default)(CollapsibleTabs, "propTypes", {
  ariaLabel: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  onTabSelect: _propTypes.default.func,
  onToggle: _propTypes.default.func,
  initialIndex: _propTypes.default.number,
  startExpanded: _propTypes.default.bool
});
var _default = exports.default = CollapsibleTabs;
//# sourceMappingURL=CollapsibleTabs.js.map